import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError } from 'rxjs/operators';
import * as _ from 'lodash';

import { setParams } from '../../../../core/config/core.httpclient-utils';
import { UiService } from '../../../../core/services/core.ui.service';
import { TrackeritemService } from '../../services/trackeritem.service';
import { TrackerRest } from '../../services/tracker.rest';
import { TrackeritemAddModalComponent } from '../../trackerItemAdd/trackerItemAddModal/trackeritem.add.modal.component'

@Component({
    selector: 'ti-related',
    template: require('./trackeritem.related-tab.component.html')
})
export class RelatedTabComponent implements OnInit, OnChanges {
    @Input() project: any;
    @Input() tracker: any;
    @Input() trackeritem: any;
    @Input() acls: any;

    addWaitingFor: any = {
        searchItemsResult: [],
        search: '',
        autoSubmitTimer: null
    };
    addBlocking: any = {
        searchItemsResult: [],
        search: '',
        autoSubmitTimer: null
    };
    AddParentParams: any;
    AddChildParams: any;
    overwriteError: boolean;
    relationItems: any;
    blockingItems: any;
    hasNoRelations: boolean = false;
    private associationsCount: number = 0;
    currentProject: any;
    customTrackerItem: any;
    allowUpdates: boolean = false;

    constructor(
        private httpClient: HttpClient,
        private modalService: NgbModal,
        private uiService: UiService,
        private trackeritemService: TrackeritemService,
        private trackerRest: TrackerRest
    ) { }

    ngOnInit() {
        this.initParams();
        this.setRelations();
        this.allowUpdates = this.getAllowUpdates();
    }

    ngOnChanges() {
        this.allowUpdates = this.getAllowUpdates();
    }

    initParams() {
        this.AddParentParams = {
            id: this.trackeritem.id,
            title: 'Add parent item in',
            subtitle: `[#${this.trackeritem.id}] ${this.trackeritem.summary}`,
            relationType: 'dependentUponBy',
            footerMessage: `Click Save to create a new <b>parent</b> item for [#${this.trackeritem.id}]`
        };

        this.AddChildParams = {
            id: this.trackeritem.id,
            title: 'Add child item in',
            subtitle: `[#${this.trackeritem.id}] ${this.trackeritem.summary}`,
            relationType: 'dependentOn',
            footerMessage: `Click Save to create a new <b>child</b> item for [#${this.trackeritem.id}]`
        };
    }

    setRelations() {
        this.relationItems = this.processRelations(this.trackeritem);
        this.blockingItems = this.relationItems.dependentOn.filter(
            (item: any) => item.itemStatusId === 1
        );
        this.updateHasNoRelations();
    }

    // <gf-associations> fetches its own data independently of trackeritem, resolving after this
    // component has already rendered -- this is how it reports back its count.
    onAssociationsLoaded(items: any[]): void {
        this.associationsCount = _.get(items, 'length', 0);
        this.updateHasNoRelations();
    }

    private updateHasNoRelations(): void {
        this.hasNoRelations =
            _.get(this.trackeritem, 'rel.dependencies.dependentOn.length', 0) === 0 &&
            _.get(this.trackeritem, 'rel.dependencies.dependentUponBy.length', 0) === 0 &&
            _.get(this.trackeritem, 'rel.duplicates.duplicatedBy.length', 0) === 0 &&
            this.associationsCount === 0;
    }

    addWaitingForSearchItems(searchValue: string) {
        this.addWaitingFor.searchItemsResult = [];
        if (searchValue.length < 3) {
            return;
        }
        this.addWaitingFor.searching = true;
        const params = {
            q: searchValue,
            s: 'trackeritem',
            project: this.tracker.project.id,
            page_num: 1,
            page_size: 20
        };

        let httpParams = new HttpParams();
        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                httpParams = httpParams.append(key, params[key].toString());
            }
        }

        this.httpClient
            .get('/api/search/', { params: httpParams })
            .pipe(
                catchError(error => {
                    const errorMsg =
                        'Sorry, ' +
                        searchValue +
                        ' does not exist or you are not allowed to view it';
                    const errorMsgTitle = 'Invalid Tracker Item';
                    this.addWaitingFor.searching = false;
                    this.addWaitingFor.search = '';
                    throw error;
                })
            )
            .subscribe((response: any) => {
                this.addWaitingFor.searchItemsResult = _.sortBy(
                    _.get(response, 'items', []),
                    ['matchScore', 'title']
                ).reverse();
                this.addWaitingFor.searching = false;
            });
    }

    addBlockingSearchItems(searchValue: string) {
        this.addBlocking.searchItemsResult = [];
        if (searchValue.length < 3) {
            return;
        }

        this.addBlocking.searching = true;
        const params = {
            q: searchValue,
            s: 'trackeritem',
            project: this.tracker.project.id,
            page_num: 1,
            page_size: 20
        };

        let httpParams = new HttpParams();
        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                httpParams = httpParams.append(key, params[key].toString());
            }
        }

        this.httpClient
            .get('/api/search/', { params: httpParams })
            .pipe(
                catchError(error => {
                    const errorMsg =
                        'Sorry, ' +
                        searchValue +
                        ' does not exist or you are not allowed to view it';
                    const errorMsgTitle = 'Invalid Tracker Item';
                    this.addBlocking.searching = false;
                    this.addBlocking.search = '';
                    throw error;
                })
            )
            .subscribe((response: any) => {
                this.addBlocking.searchItemsResult = _.sortBy(
                    _.get(response, 'items', []),
                    ['matchScore', 'title']
                ).reverse();
                this.addBlocking.searching = false;
            });
    }

    addRelatedItem(item: any, selectedType: string) {
        if (!this.allowUpdates || !this.acls?.canUpdate) return;

        this.addWaitingFor.search = '';
        this.addWaitingFor.searchItemsResult = [];

        this.addBlocking.search = '';
        this.addBlocking.searchItemsResult = [];

        let d;
        if (selectedType === 'dependentOn') {
            d = this.relatedAdd(
                this.trackeritem.id,
                item.refId,
                this.trackeritem.lastModifiedDate
            );
        }
        if (selectedType === 'dependentUponBy') {
            d = this.relatedAdd(
                item.refId,
                this.trackeritem.id,
                this.trackeritem.lastModifiedDate
            );
        }

        d.then((data: any) => {
            this.updateRelationsUI(data);
        })
            .catch(err => {
                if (_.has(err, 'overwrite')) {
                    this.overwriteError = true;
                }

                const errMsg =
                    err.relatedId || 'There was an error trying to add the tracker item relation';
                // UiService.message.showError(errMsg);
            });
    }

    addWaitingForAutoSubmit(searchValue: string) {
        if (this.addWaitingFor.autoSubmitTimer) {
            clearTimeout(this.addWaitingFor.autoSubmitTimer);
        }
        this.addWaitingFor.autoSubmitTimer = setTimeout(() => {
            this.addWaitingForSearchItems(searchValue);
        }, 750);
    }

    addBlockingAutoSubmit(searchValue: string) {
        if (this.addBlocking.autoSubmitTimer) {
            clearTimeout(this.addBlocking.autoSubmitTimer);
        }
        this.addBlocking.autoSubmitTimer = setTimeout(() => {
            this.addBlockingSearchItems(searchValue);
        }, 750);
    }

    deleteRelatedItem(item: any) {
        if (!this.allowUpdates || !this.acls?.canUpdate) return;

        if (item.iconClass !== 'glyphicon-link') {
            this.relatedDelete(
                this.trackeritem.id,
                item.itemId,
                this.trackeritem.lastModifiedDate
            )
                .then((data: any) => { this.updateRelationsUI(data) })
                .catch(err => {
                    if (_.has(err, 'overwrite')) {
                        this.overwriteError = true;
                    }
                });
        } else {
            this.trackerRest.deleteAssociation(this.trackeritem.id, item.itemId)
                .then((data: any) => { this.updateRelationsUI(data) })
                .catch(function (err) {
                    if (_.has(err, 'overwrite')) {
                        this.overwriteError = true;
                    }
                });
        }
    }

    getAllowUpdates(): boolean {
        const ret = this.trackeritemService.allowUpdates(this.trackeritem) &&
            (this.acls?.canUpdate || this.acls?.isAdmin);
        return ret;
    }

    removeTIDependency(ti: any) {
        if (!this.allowUpdates || !this.acls?.canUpdate) return;

        this.relatedDelete(this.trackeritem.id, ti.id, this.trackeritem.lastModifiedDate)
            .then((data: any) => this.updateRelationsUI(data))
            .catch((err: any) => {
                if (_.has(err, 'overwrite')) {
                    this.overwriteError = true;
                }
            });
    }

    updateRelationsUI(data: any) {
        this.trackeritem.lastModifiedDate = _.get(data, 'lastModifiedDate', this.trackeritem.lastModifiedDate);

        //get updated data from the item
        this.httpClient.get('/api/trackeritem/' + this.trackeritem.id + '?rel=history,dependencies,associations')
            .toPromise()
            .then((response: any) => {
                this.trackeritem.rel.history = _.get(response, 'rel.history', []);
                this.trackeritem.rel.dependencies = _.get(response, 'rel.dependencies', []);
                this.trackeritem.rel.associations = _.get(response, 'rel.associations', []);

                this.setRelations();
            });
    };


    goToRelatedItem(item: any) {
        this.uiService.state.goToItem(item.section, item.itemId, null, item?.project?.unixName);
    }

    itemRelationsCount(): number {
        return _.get(this.relationItems, 'dependentOn.length', 0)
            + _.get(this.relationItems, 'dependentUponBy.length', 0)
            + _.get(this.relationItems, 'duplicateOf.length', 0)
            + _.get(this.relationItems, 'duplicateBy.length', 0)
            + _.get(this.relationItems, 'associated.length', 0);
    }

    public openTrackeritemAddModal(params: any) {
        if (!this.allowUpdates || !this.acls?.canSubmit) return;

        const projectTrackers: any = _.get(this.project, 'rel.trackers', []);

        const modalRef = this.modalService.open(TrackeritemAddModalComponent);
        // pass params
        modalRef.componentInstance.tracker = this.tracker;
        modalRef.componentInstance.trackers = projectTrackers;
        modalRef.componentInstance.project = this.currentProject;
        modalRef.componentInstance.customTrackeritem = this.customTrackerItem;
        modalRef.componentInstance.params = params;
        modalRef.componentInstance.onCreate.subscribe((event: any) => {
            this.trackeritemAddModalCallback(event.trackeritem, event.params);
            if (!event.keepOpen) {
                modalRef.close();
            }
        });
        modalRef.componentInstance.onClose.subscribe(() => {
            modalRef.close();
        });
    }

    trackeritemAddModalCallback(trackeritem: any, params: any) {
        this.addRelatedItem({ refId: trackeritem.id }, params.relationType);
    }

    relatedAdd(trackerItemId: any, relatedTrackerItemId: any, lastModifiedDate: any): Promise<any> {
        const params: any = { id: trackerItemId, relatedTrackerItemId: relatedTrackerItemId };

        return this.httpClient.post(`/api/trackeritem/${trackerItemId}/related/${relatedTrackerItemId}?lastModifiedDate=${lastModifiedDate}`, params)
            .toPromise()
            .then((data: any) => {
                this.uiService.message.showSuccess("Tracker item relation added");
                return data;
            }, (err: any) => {
                // const errMsg = err.relatedId || "There was an error trying to add the tracker item relation";
                // this.uiService.message.showError(errMsg);
            });
    }

    relatedDelete(trackerItemId: any, relatedTrackerItemId: any, lastModifiedDate: any): Promise<any> {
        const params: any = {};
        if (lastModifiedDate) {
            params.lastModifiedDate = lastModifiedDate;
        }

        return this.httpClient.delete(`/api/trackeritem/${trackerItemId}/related/${relatedTrackerItemId}`, { params: setParams(params) })
            .toPromise()
            .then((data) => {
                this.uiService.message.showSuccess("Tracker item relation removed");
                return data;
            }, (err: any) => {
                const errMsg = err.relatedTrackerItemId || "There was an error trying to remove the tracker item relation";
                this.uiService.message.showError(errMsg);
            });
    }

    trackById(index, item) {
        return item.id; // or however you identify items uniquely
    }

    processRelations(tiData: any): any {
        const _relationItems: any = {
            dependentOn: [],
            dependentUponBy: [],
            duplicateOf: [],
            duplicateBy: [],
            associated: []
        };

        const relatedItemsElementsMapping: any = {
            dependentOn: { relationType: 'dependentOn', text: 'Current task <strong>is a parent of', boxClass: 'dependency dependentOn', iconClass: '/core/img/dep-child.png', itemTypeName: 'task', descriptionField: 'summary' },
            dependentUponBy: { relationType: 'dependentUponBy', text: 'Current task <strong>is a child of', boxClass: 'dependency dependentUponBy', iconClass: '/core/img/dep-parent.png', itemTypeName: 'task', descriptionField: 'summary' },
            duplicateOf: { relationType: 'duplicateOf', text: 'Current task <strong>is a duplicate of</strong>', boxClass: 'duplicateOf', iconClass: 'glyphicon-retweet' },
            duplicateBy: { relationType: 'duplicateBy', text: 'Current task <strong>is duplicated by</strong>', boxClass: 'duplicateBy', iconClass: 'glyphicon-retweet' }
        };

        Object.keys(tiData).forEach((element: string) => {
            if (relatedItemsElementsMapping[element]) {
                tiData[element].forEach((item: any) => {
                    _relationItems[element].push({
                        itemId: item.id,
                        section: 'trackeritem',
                        description: item.summary,
                        text: relatedItemsElementsMapping[element].text,
                        linkTitle: "Go to this task",
                        boxClass: relatedItemsElementsMapping[element].boxClass,
                        iconClass: relatedItemsElementsMapping[element].iconClass
                    });
                });
            }
        });

        const sectionMapping: any = {
            trackeritem: { itemTypeName: 'Task', descriptionField: 'summary' },
            forummessage: { itemTypeName: 'Forum Message', descriptionField: 'subject' },
            docmanfile: { itemTypeName: 'Document File', descriptionField: 'description' },
            wikipage: { itemTypeName: 'Wiki Page', descriptionField: 'pagename' },
            scmcommit: { itemTypeName: 'SCM Commit', descriptionField: 'messageLog' },
            frsrelease: { itemTypeName: 'FRS Release', descriptionField: '' }
        };

        tiData.rel.associations &&
        Object.keys(tiData.rel.associations).forEach((section: string) => {
            tiData.rel.associations[section].forEach((itemArr: any) => {
                _relationItems.associated.push({
                    section: section,
                    itemTypeName: sectionMapping[section].itemTypeName,
                    boxClass: 'association',
                    iconClass: 'glyphicon-link',
                    itemId: itemArr.id,
                    text: `Current task <strong>is associated to ${sectionMapping[section].itemTypeName}</strong>`,
                    linkTitle: `Go to this ${sectionMapping[section].itemTypeName}`,
                    description: itemArr[sectionMapping[section].descriptionField],
                    comment: itemArr.comment
                });
            });
        });

        tiData.rel.dependencies &&
        Object.keys(tiData.rel.dependencies).forEach((relationType: string) => {
            tiData.rel.dependencies[relationType].forEach((itemArr: any) => {
                _relationItems[relationType].push({
                    section: 'trackeritem',
                    itemStatusId: itemArr.statusId,
                    itemTypeName: relatedItemsElementsMapping[relationType].itemTypeName,
                    boxClass: relatedItemsElementsMapping[relationType].boxClass,
                    iconClass: relatedItemsElementsMapping[relationType].iconClass,
                    itemId: itemArr.id,
                    text: `${relatedItemsElementsMapping[relationType].text} ${relatedItemsElementsMapping[relationType].itemTypeName}`,
                    linkTitle: `Go to this ${relatedItemsElementsMapping[relationType].itemTypeName}`,
                    description: itemArr[relatedItemsElementsMapping[relationType].descriptionField],
                    comment: itemArr.comment
                });
            });
        });

        return _relationItems;
    }

    removeDependentUponByTrackeritem(ti: any) {
        _.remove(this.trackeritem.rel.dependencies.dependentUponBy, { id: ti.id });
    }

    removeDependentOnTrackeritem(ti: any) {
        _.remove(this.trackeritem.rel.dependencies.dependentOn, { id: ti.id });
    }
}














